export const CHART_WIDTH = 800;
export const CHART_HEIGHT = 400;

export const USE_REAL_RANDOM = false;
